// Hooks
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

// Common style components
import { StyledDashedSeparator } from '../../common/styles/Separators';
import { StyledLabel } from '../../common/styles/devices/Labels';
import { StyledTextInput } from '../../common/styles/devices/Texts';
import { StyledEditPanelContainer } from '../../common/styles/devices/Container';

// Common field components
import { StandardSelector, DaySelector  } from '../../common/fields/devices/Selector';
import { Row, Column } from '../../common/fields/PageUtils';
// import { StandardButton } from '../../common/fields/Buttons';
import { SaveButton, RemoveButton } from '../../common/fields/devices/Buttons';
import { StandardEditDisplayMessage, OverlappingMessage } from '../../common/fields/devices/DisplayMessages';
import { messages_common, messages_quiet_periods } from '../../common/types/Messages';
import { DisplayDevicesEditSchedules, DevicesEditActions } from '../../common/fields/devices/Container';

// Store
import { editSchedule, saveScheduleToDb, saveSchedulesToDb } from '../../../store/rules/ruleSchedulesSlice';
import { editRule, saveRuleToDb, saveRulesToDb } from '../../../store/rules/rulesSlice';
import { getSettings } from '../../../store/rules/settingsSlice';
import { EditSchedule, Status } from '../../../store/rules/types';

// Helpers
import { cloneDeep } from 'lodash';

// Other
import moment from 'moment';

export function EditPanel({schedule, schedules, rules, isOverlapping}: {schedule: EditSchedule; schedules: EditSchedule[]; rules: any; isOverlapping: any;}) {
  
  const linkedRules = rules.filter(rule => rule.schedules_id === schedule.schedules_id);  
  const mainRule = linkedRules[0] || null;
  
  // Check if any schedules and rules are unsaved
  const save_all_enabled = schedules.filter(schedule => !schedule.saved).length > 0? true : false;
  const rules_all_enabled = rules.filter(rule => !rule.saved).length > 0? true : false;
  
  const globalSettings = useSelector(getSettings);
  const dispatch = useDispatch();  
  
  return (
    <StyledEditPanelContainer>
    
      {mainRule !== null &&
        <StyledTextInput
          disabled={false}
          value={mainRule.title}
          onChange={(text_event) => dispatch(editRule({id: mainRule.id, title: text_event.target.value}))}
        />
      }
      
      <DisplayDevicesEditSchedules show={schedule.editable}>
        
        <Row>
          <Column>
            <StyledLabel>Start</StyledLabel>
            <StandardSelector  
              parameter={schedule.dtstart} 
              onChange={(select_event) => dispatch(editSchedule({ id: schedule.id, dtstart: moment(schedule.dtstart).hours(select_event.target.value).format('YYYY-MM-DD HH:mm:ss')})) }
              array={Array.from(Array(25).keys())}
              type='Hour'
            />
          </Column>
          
          <Column>
            <StyledLabel>Duration</StyledLabel>
            <StandardSelector 
              parameter={schedule.duration}
              onChange={(select_event) => dispatch(editSchedule({id: schedule.id, duration: select_event.target.value*3600}))}
              array={Array.from({length: 48}, (_, i) => i + 1)}
              type='Duration'
            />
          </Column>
        </Row>
        
        <Row>
          <DaySelector 
            selected={schedule.byweekday} 
            labels={['M', 'T', 'W', 'T', 'F', 'S', 'S']} 
            onChange={(select_event) => dispatch(editSchedule({id: schedule.id, byweekday: select_event.selected}))}
            type='DayRepeat'
          />
        </Row>      
        
        <Row>
          <DevicesEditActions schedule={schedule}>
            <RemoveButton disabled={false} onClick={() => {
              dispatch(saveRuleToDb({...cloneDeep(mainRule), status: Status.DETACHED}));
              dispatch(saveScheduleToDb({...cloneDeep(schedule), status: Status.DETACHED}));
            }} text="Remove"/>
            
            <SaveButton disabled={(schedule.saved && mainRule.saved) || isOverlapping.state} onClick={() => {
               dispatch(saveScheduleToDb(schedule));
               dispatch(saveRuleToDb(mainRule))}} text="Save"/>               
          </DevicesEditActions>
        </Row>
        
      </DisplayDevicesEditSchedules>
      
      {globalSettings.message.length > 0? 
        <Row>
          <StandardEditDisplayMessage message={globalSettings.message}></StandardEditDisplayMessage>         
        </Row>
      : null }
      
      <StyledDashedSeparator/>
      
      <Row>
        <DevicesEditActions schedule={schedule}>
          <SaveButton disabled={!(save_all_enabled || rules_all_enabled) || isOverlapping.state} onClick={() => {
            dispatch(saveSchedulesToDb(schedules));
            dispatch(saveRulesToDb(rules))}} text="Save All"/>
        </DevicesEditActions>
      </Row>
      
      {isOverlapping.state && <Row>
        <OverlappingMessage isOverlapping={isOverlapping}/>
      </Row>}
      
      {!isOverlapping.state && <Row>
        <StandardEditDisplayMessage message={messages_common.save}/>
      </Row>}

      <Row>
      <StandardEditDisplayMessage message={messages_quiet_periods.description}/>
      </Row>
      
    </StyledEditPanelContainer>
  );
}